export default __webpack_public_path__ + "b387b681932cdbcec2a203f3a5b90870.png";